<template>
    <div style="height: 100%;" class="loginStyle flexs">
        <div class="loginLeft re"> 
            <!-- <img class="ab" src="../assets/img/T01_08_home.png"> -->
            <img class="ab" src="../assets/img/T24_03_13.png">
        </div>
        <div style="width:570px;" class="re">
            <div style="width: 350px;" class="ab lobin_form">
                <div class="login_title">
                    <span style="font-size: 36px;">消费者业务平台</span>
                    <p style="text-align:center;font-size: 15px;font-weight: 400;padding-top:3px;color:#777;">方便、快捷</p>
                </div>
                
                <el-form :model="loginForms" ref="loginForms" :rules="rules" class="demo-ruleForm">
                    <el-form-item prop="userName" :rules="filter_rules({required:true,type:'userName',message:' ',min:5,max:45})">
                        <el-input prefix-icon="el-icon-user" v-model.trim="loginForms.userName" maxlength="45" placeholder="请输入用户名" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="passWord">
                        <el-input prefix-icon="el-icon-unlock" show-password v-model.trim="loginForms.passWord"  maxlength="16" placeholder="请输入密码" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="imgCode" style="position:relative;">
                        <el-input prefix-icon="el-icon-picture-outline-round" v-model.trim="loginForms.imgCode" placeholder="请输入验证码" :maxlength='4' clearable style="width:220px;"></el-input>
                        <span class="yzmimg" style="">
                            <img :src='codeSrc' @click="getCode()" alt="">
                        </span>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="logins" round @click.native.prevent="codeLogin('loginForms')" @keyup.enter.native="codeLogin('loginForms')" style="">登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
                        <p style="text-align: center;" class="cancel"><span class="cursors" @click="resetForm('loginForms')">取 消</span></p>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
    var axios = require('axios')
    import {mapActions} from "vuex";
    export default {
        name: 'login',
        data() {
            return {
                codeSrc: "",
                rules: {
                    imgCode: [
                        {required: true, message: ' ', trigger: ["blur", "change"]},
                        { min: 4, message: " ",trigger: ["blur", "change"]}
                    ],
                    passWord:[
                        {required: true, message: ' ', trigger: ["blur", "change"]},
                    ],
                },
                loginForms: {
                    userName: '',
                    passWord: '',
                    imgCode: ''
                },
            };
        },
        methods: {
            ...mapActions([
                'saveInfo'
            ]),
            //登录
            codeLogin(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.IsCode();
                    } else {
                        return false;
                    }
                });
            },
            //获取验证码
            getCode() {
                this.codeSrc = this.API.url + "imgCode?d=" + Math.random();
            },
            //判断验证码是否正确
            IsCode() {
                axios.defaults.withCredentials = true;
                axios({
                    method: 'post',
                    url: this.API.url + 'checkImgCode',
                    data: {'imgCode': this.loginForms.imgCode},
                    transformRequest: [function (data) {
                        let ret = ''
                        for (let it in data) {
                            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
                        }
                        return ret
                    }],
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
                }).then(resd => {
                    if (resd.data.code == 200) {
                        this.loginSend();
                    } else {
                        this.getCode(); //重新获取验证码
                        this.loginForms.imgCode = ''; //验证码制空
                        return false;
                    }
                })
            },
            //发送登录请求
            loginSend() {
                let obj = {};
                Object.assign(obj, this.loginForms);
                obj.passWord = this.$md5(obj.passWord);
                axios.defaults.withCredentials = true;
                axios({
                    method: 'post',
                    url: this.API.url + 'login',
                    data: obj,
                }).then(resd => {
                    if (resd.data.code == 200) {
                        document.cookie = "tibiot-personal-card=Bearer " + resd.data.data.val + ";path=/;"
                        this.$router.push('/home'); //跳转页面
                    } else {
                        this.getCode(); //重新获取验证码
                        this.$message.error(resd.data.message);
                    }
                })
            },
            //重置
            resetForm(formName){
                this.$refs[formName].resetFields();
            }
        },
        created() {
            //清除token
            if (this.$common.getCookie('tibiot-personal-card')) {
                document.cookie = 'tibiot-personal-card=' + this.$common.getCookie('tibiot-personal-card') + ';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT';
                window.localStorage.removeItem("vuex-along");//清除vue-along
            }
            this.getCode(); //重新获取验证码
            // 注册回车事件
            var _self = this;
            document.onkeydown = function (e) {
                let keys = 0;
                if (window.event == undefined) {
                    keys = e.keyCode;
                } else {
                    keys = window.event.keyCode;
                }
                if (keys == 13) {
                    _self.codeLogin('loginForms');
                }
            }
        }
    };
</script>
<style scoped>
    .loginStyle {
        min-width:1100px;
        background: #fff;
    }
    .loginLeft{
        width:calc(100% - 570px);
        background:#d0dcf4;
        border-radius: 0px 22px 22px 0px;
        box-shadow: 0px 0px 10px 4px #dddee1;
    }
    .loginLeft img{
        width:480px;
        top:50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .lobin_form{
        top:50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .login_title{
        text-align: center;
        margin-bottom:32px;
        font-weight: 700;
        font-size: 32px;
        color:#222;
    }
    .logins{
        display: inline-block;
        font-size: 16px;
        width:100%;
        margin-top:16px;
    }
    .yzmimg{
        background:#fff;
        display:block;
        position:absolute;
        right:0px;
        top:0px;
        width:107px;
        height:38px;
        border:1px solid #dcdfe6;
        border-radius:20px;
        font-size: 0px;
        overflow: hidden;
    }
    .yzmimg img{
        padding-top:3px;
        padding-left:3px;
    }
    .cancel{
        color:#999;
        font-size: 13px;
        font-weight: 500;
    }
    .cancel:hover{
        color:#333;
        
    }
    /* 宽度大于1024px至无穷时 */  
    @media (min-width: 1300px) {  
        .loginLeft img{
            width:68%;
        }
    }
    @media (min-width: 1900px) {  
        .loginLeft img{
            width:50%;
        }
    }
    .el-form-item{
        margin-bottom: 16px;
    }

</style>
<style>
.loginStyle .el-input__inner{
    border-radius: 20px;
}
.loginStyle .el-input--prefix .el-input__inner{
    padding-left: 35px;;
}
.loginStyle .el-input__prefix{
    left:9px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue